import { Injectable } from '@angular/core';
import {
  County,
  Location,
  LocationConnection,
} from '../../model/locations/location';
import { BusinessUnit } from 'src/app/model/admin/business-unit';

@Injectable({
  providedIn: 'root',
})
export class LocationBuilderService {
  buildLocation(item: any): Location {
    const location = {
      id: item.id,
      state: item.state,
      county: item.county,
      township: item.township,
      updater: item.updater,
      deletedAt: item.deletedAt,
      businessUnits: item.businessUnits,
      businessUnitString: item?.businessUnits
        ?.map((i: BusinessUnit) => i.name)
        ?.join(', '),
    };

    return location;
  }

  buildLocationConnection(item: any): LocationConnection {
    return {
      items: item.items.map((i: any) => this.buildLocation(i)),
      totalRecords: item.totalRecords,
    };
  }

  buildCounty(item: any): County {
    return {
      county: item.county,
      state: item.state,
    };
  }
}
